"use client"
import styled from "@emotion/styled"
import { IconButton } from "@mui/material"
import { useState } from "react"
import { XIcon } from "ui"
import { ProjectPage } from "utils"
import CountdownTimer from "./CountdownTimer"

const TimerPopupStyled = styled.div<{
  isClosed: boolean
  isDesktop: boolean
  heroInView?: boolean
}>`
  background-color: ${(props) => props.theme.colors.darkBlue4rentMarketing};
  min-height: 73px;
  width: 100%;
  color: white;

  font-size: 14px;
  font-weight: 300;
  line-height: 150%;

  display: flex;
  justify-content: center;

  position: fixed;
  z-index: 11;
  top: ${(props) => (props.isClosed ? "-200px" : "0")};
  opacity: ${(props) => (props.isClosed ? 0 : 1)};
  right: 0;

  gap: 140px;
  border-radius: 0 0 12px 12px;
  padding: 8px 20px;
  padding-inline-end: 10px;
  transition: all 0.3s ease-in-out;

  ${({ isDesktop, heroInView }) =>
    !isDesktop
      ? ""
      : `
    display: flex;
    min-height: unset;
    height: 64px;
    position: ${heroInView ? "relative" : "sticky"};
    font-size: 24px;
    letter-spacing: -0.48px;
    padding: 8px 24px;
    border-radius: 0;
    justify-content: unset;
  `}
  strong {
    font-weight: 500;

    font-size: 18px;
    line-height: 150%;

    @media screen and (min-width: 410px) {
      font-size: 20px;
    }
    ${({ isDesktop }) =>
      !isDesktop
        ? ""
        : `
      order: 0;
      padding-inline: 0;
      display: flex;
      font-size: 40px;
      line-height: 120%;
      font-size: 24px;
      letter-spacing: -0.48px;`}
  }
`

const TimerTextWrapper = styled.div<{ isDesktop: boolean }>`
  display: flex;
  width: 100%;
  gap: 4px;
  align-items: center;
  flex-wrap: wrap;
  ${({ isDesktop }) =>
    !isDesktop
      ? ""
      : `
    gap: 6px;
    flex-wrap: nowrap;
 `}
`
const IconButtonStyled = styled(IconButton)<{ isDesktop: boolean }>`
  order: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: flex-end;
  ${({ isDesktop }) =>
    !isDesktop
      ? ""
      : `
    display: none;
      `}

  svg {
    width: 16px;
    height: 16px;
    ${(props) => props.theme.breakpoints.up("md")} {
      width: 24px;
      height: 24px;
    }
  }
  ${(props) => props.theme.breakpoints.down("sm")} {
    padding-inline: 0;
  }
`
type Props = {
  locale: string
  rentProjectFOMO: ProjectPage["rentProjectFOMO"]
  handleHide: () => void
  forDesktop?: boolean
  heroInView?: boolean
}

const TimerPopup = ({ rentProjectFOMO, locale, handleHide, forDesktop, heroInView }: Props) => {
  const [isClosed, setIsClosed] = useState<boolean>(false)
  const handleClose = () => {
    setIsClosed(true)
  }
  return (
    <TimerPopupStyled isClosed={isClosed} isDesktop={!!forDesktop} heroInView={heroInView}>
      <IconButtonStyled onClick={handleClose} className="closeButton" isDesktop={!!forDesktop}>
        <XIcon color={"white"} />
      </IconButtonStyled>
      <TimerTextWrapper isDesktop={!!forDesktop}>
        <span className="beforeText">{rentProjectFOMO?.textsBeforeTimer} </span>
        <CountdownTimer
          target={rentProjectFOMO!.timer}
          locale={locale}
          showDays
          showMonthsYears
          onEnd={handleHide}
        />{" "}
        <span className="afterText">{rentProjectFOMO?.textAfterTimer}</span>
      </TimerTextWrapper>
    </TimerPopupStyled>
  )
}
export default TimerPopup
